/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

const ezgraphRegexp = /^\[([^\]]*)]\s*\(ezgraph:([^)]+)\s*\)/;
let rule = (state, silent) => {
  if (!state.src) {
    return false;
  }
  const pos = state.pos;
  const match = ezgraphRegexp.exec(state.src.slice(pos));
  if (!match) {
    return false;
  }
  if (!silent) {
    const openToken = {
      type: "ezgraph_open",
      content: {
        id: match[2],
        displayName: match[1]
      },
      level: state.level
    };
    state.push(openToken);
    const spaceToken = {
      type: "text",
      content: match[1],
      //content: "\u200b", // hack: this is a zero-width space, but I need a place for markdown-to-draft to hang the entity
      level: state.level + 1
    };
    state.push(spaceToken);
    const closeToken = {
      type: "ezgraph_close",
      level: state.level
    };
    state.push(closeToken);
    state.pos += match[0].length;
  }
  return true;
};
export function abMarkdownEzGraphPlugin(remarkable) {
  // converts Markdown ezgraph link text to a triple of tokens: ezgraph_open, space, ezgraph_closed.
  remarkable.inline.ruler.before("links", "ezgraph", rule, {});
}
//# sourceMappingURL=AbMarkdownEzGraphPlugin.js.map
